import { render, staticRenderFns } from "./ShowCustomerPayments.vue?vue&type=template&id=7d12f4a6&scoped=true&"
import script from "./ShowCustomerPayments.vue?vue&type=script&lang=js&"
export * from "./ShowCustomerPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d12f4a6",
  null
  
)

export default component.exports